import { ViewEncapsulation } from '@angular/compiler';
import { Component } from '@angular/core';
import { LoaderService } from 'common/services/core-services/loader.service';

@Component({
    selector: 'sm-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
    constructor(public loader: LoaderService) {}
}
